import React from 'react';
import RepositoryTemplate from '../../templates/Repository/RepositoryTemplate';

export default function Repository() {
  return <RepositoryTemplate />;
}
